import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal flight-details" }
const _hoisted_2 = ["title"]
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 1,
  src: "/public/assets/img/LetsDoPlaceholder.jpg",
  alt: "",
  width: "20",
  height: "20"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("th", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("span")
], -1)
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = {
  key: 0,
  class: "stopover"
}
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_13 = ["src"]
const _hoisted_14 = {
  key: 1,
  src: "/public/assets/img/LetsDoPlaceholder.jpg",
  alt: "",
  width: "20",
  height: "20"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("th", null, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("span")
], -1)
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = {
  key: 0,
  class: "stopover"
}
const _hoisted_20 = {
  class: "mobile-footer",
  hidden: ""
}
const _hoisted_21 = { class: "center-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EasyDrop = _resolveComponent("EasyDrop")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    modelValue: _ctx.showModal,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showModal) = $event)),
    close: _ctx.closeModal,
    onBeforeEnter: _ctx.fixBody,
    onAfterLeave: _ctx.unfixBody
  }, {
    default: _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        _createElementVNode("header", null, [
          _createElementVNode("button", {
            class: "close-btn",
            title: _ctx.pageTexts['hotelPageGeneralModalButtonClose'],
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
          }, null, 8, _hoisted_2),
          _createElementVNode("h2", null, _toDisplayString(_ctx.pageTexts['hotelPageFlightStepModalItineraryHeadline']), 1)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("article", null, [
            _createElementVNode("header", null, [
              _createElementVNode("div", null, [
                _createElementVNode("strong", null, [
                  _createTextVNode(_toDisplayString(_ctx.pageTexts['hotelPageTravelOverviewLabelFlightDeparture']) + " ", 1),
                  _createElementVNode("abbr", null, _toDisplayString(_ctx.flight.toDestinationSummary.startDepartureAirportCode), 1),
                  _hoisted_4,
                  _createElementVNode("abbr", null, _toDisplayString(_ctx.flight.toDestinationSummary.endArrivalAirportCode), 1),
                  _createTextVNode("     " + _toDisplayString(_ctx.formatLongDate(_ctx.flight.toDestinationSummary.startDepartureDate)), 1)
                ]),
                _createElementVNode("span", null, _toDisplayString(_ctx.formatTotalTravelTime(_ctx.flight.toDestinationSummary.totalTravelTime)) + " " + _toDisplayString(_ctx.flight.toDestinationSummary.stopOvers.length) + " " + _toDisplayString(_ctx.pageTexts['hotelPageFlightStepFilterPopupLabelDropdownStop']), 1)
              ])
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.flight.toDestinationSummary.flights, (plane, index) => {
              return (_openBlock(), _createElementBlock("section", { key: index }, [
                _createElementVNode("table", null, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", null, _toDisplayString(_ctx.pageTexts['hotelPageTravelOverviewLabelFlight']) + " " + _toDisplayString(index + 1), 1),
                      _createElementVNode("th", null, [
                        (plane.airlineIcon)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: plane.airlineIcon,
                              alt: "",
                              width: "20",
                              height: "20"
                            }, null, 8, _hoisted_5))
                          : (_openBlock(), _createElementBlock("img", _hoisted_6)),
                        _createTextVNode(" " + _toDisplayString(plane.airlineName) + " " + _toDisplayString(plane.flightNumber), 1)
                      ]),
                      _hoisted_7
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", null, [
                        _createElementVNode("abbr", null, _toDisplayString(plane.departureAirportCode), 1),
                        _createElementVNode("time", null, _toDisplayString(_ctx.formatTime(plane.departureTime)), 1),
                        _createElementVNode("span", null, _toDisplayString(_ctx.formatDate(plane.departureTime)), 1)
                      ]),
                      _createElementVNode("td", null, [
                        _hoisted_8,
                        _createElementVNode("span", null, _toDisplayString(_ctx.formatTotalTravelTime(plane.flyingTime)), 1)
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("abbr", null, _toDisplayString(plane.arrivalAirportCode), 1),
                        _createElementVNode("time", null, _toDisplayString(_ctx.formatTime(plane.arrivalTime)), 1),
                        _createElementVNode("span", null, _toDisplayString(_ctx.formatDate(plane.arrivalTime)), 1)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createVNode(_component_EasyDrop, {
                    position: 'center',
                    "has-top-tip": true,
                    customButtonClasses: 'main-drop'
                  }, {
                    buttonText: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.pageTexts['hotelPageFlightStepModalItineraryDetails']), 1)
                    ]),
                    content: _withCtx(() => [
                      _createElementVNode("ul", null, [
                        (plane.cabinClass)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_9, _toDisplayString(plane.cabinClass), 1))
                          : _createCommentVNode("", true),
                        (_ctx.flight.baggageWeight)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_10, _toDisplayString(_ctx.pageTexts['hotelPageFlightStepModalItineraryLuggage']) + " " + _toDisplayString(_ctx.flight.baggageWeight) + " kg", 1))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                (_ctx.flight.toDestinationSummary.flights[index + 1])
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.pageTexts['hotelPageFlightStepModalItineraryStopOver']) + ": ", 1),
                      _createTextVNode(" " + _toDisplayString(_ctx.formatDifferenceTime(plane.arrivalTime,
                                    _ctx.flight.toDestinationSummary.flights[index + 1].departureTime)) + " " + _toDisplayString(_ctx.pageTexts['hotelPageFlightStepModalItineraryIn']) + " ", 1),
                      _createElementVNode("abbr", null, _toDisplayString(plane.arrivalAirportCityName), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]),
          _createElementVNode("article", null, [
            _createElementVNode("header", null, [
              _createElementVNode("div", null, [
                _createElementVNode("strong", null, [
                  _createTextVNode(_toDisplayString(_ctx.pageTexts['hotelPageTravelOverviewLabelFlightArrival']) + " ", 1),
                  _createElementVNode("abbr", null, _toDisplayString(_ctx.flight.fromDestinationSummary.startDepartureAirportCode), 1),
                  _hoisted_12,
                  _createElementVNode("abbr", null, _toDisplayString(_ctx.flight.fromDestinationSummary.endArrivalAirportCode), 1),
                  _createTextVNode("     " + _toDisplayString(_ctx.formatLongDate(_ctx.flight.fromDestinationSummary.startDepartureDate)), 1)
                ]),
                _createElementVNode("span", null, _toDisplayString(_ctx.formatTotalTravelTime(_ctx.flight.fromDestinationSummary.totalTravelTime)) + " " + _toDisplayString(_ctx.flight.fromDestinationSummary.stopOvers.length) + " " + _toDisplayString(_ctx.pageTexts['hotelPageFlightStepFilterPopupLabelDropdownStop']), 1)
              ])
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.flight.fromDestinationSummary.flights, (plane, index) => {
              return (_openBlock(), _createElementBlock("section", { key: index }, [
                _createElementVNode("table", null, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", null, _toDisplayString(_ctx.pageTexts['hotelPageTravelOverviewLabelFlight']) + " " + _toDisplayString(index + 1), 1),
                      _createElementVNode("th", null, [
                        (plane.airlineIcon)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: plane.airlineIcon,
                              alt: "",
                              width: "20",
                              height: "20"
                            }, null, 8, _hoisted_13))
                          : (_openBlock(), _createElementBlock("img", _hoisted_14)),
                        _createTextVNode(" " + _toDisplayString(plane.airlineName) + " " + _toDisplayString(plane.flightNumber), 1)
                      ]),
                      _hoisted_15
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", null, [
                        _createElementVNode("abbr", null, _toDisplayString(plane.departureAirportCode), 1),
                        _createElementVNode("time", null, _toDisplayString(_ctx.formatTime(plane.departureTime)), 1),
                        _createElementVNode("span", null, _toDisplayString(_ctx.formatDate(plane.departureTime)), 1)
                      ]),
                      _createElementVNode("td", null, [
                        _hoisted_16,
                        _createElementVNode("span", null, _toDisplayString(_ctx.formatTotalTravelTime(plane.flyingTime)), 1)
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("abbr", null, _toDisplayString(plane.arrivalAirportCode), 1),
                        _createElementVNode("time", null, _toDisplayString(_ctx.formatTime(plane.arrivalTime)), 1),
                        _createElementVNode("span", null, _toDisplayString(_ctx.formatDate(plane.arrivalTime)), 1)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createVNode(_component_EasyDrop, {
                    position: 'center',
                    "has-top-tip": true,
                    customButtonClasses: 'main-drop'
                  }, {
                    buttonText: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.pageTexts['hotelPageFlightStepModalItineraryDetails']), 1)
                    ]),
                    content: _withCtx(() => [
                      _createElementVNode("ul", null, [
                        (plane.cabinClass)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_17, _toDisplayString(plane.cabinClass), 1))
                          : _createCommentVNode("", true),
                        (_ctx.flight.baggageWeight)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_18, _toDisplayString(_ctx.pageTexts['hotelPageFlightStepModalItineraryLuggage']) + " " + _toDisplayString(_ctx.flight.baggageWeight) + " kg", 1))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                (_ctx.flight.fromDestinationSummary.flights[index + 1])
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.pageTexts['hotelPageFlightStepModalItineraryStopOver']) + ": ", 1),
                      _createTextVNode(" " + _toDisplayString(_ctx.formatDifferenceTime(plane.arrivalTime,
                                    _ctx.flight.fromDestinationSummary.flights[index + 1].departureTime)) + " " + _toDisplayString(_ctx.pageTexts['hotelPageFlightStepModalItineraryIn']) + " ", 1),
                      _createElementVNode("abbr", null, _toDisplayString(plane.arrivalAirportCityName), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("button", {
              class: "btn-primary",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
            }, _toDisplayString(_ctx.pageTexts['hotelPageNavigationButtonBack']), 1)
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "close", "onBeforeEnter", "onAfterLeave"]))
}